export const server = {
  DEFAULT_DATE_FORMAT: 'year/month/day',
  VERSION: '14.4'
}

export const tipoAnalisisControlMorfologicoSeguimiento = {
  ANALISIS: 1,
  CONTROL_MORFOLOGICO: 2,
  SEGUIMIENTO: 3
}